module.exports = __webpack_public_path__ + "img/chronic_pain.ed67d74b.png";